import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CountryISO, SearchCountryField, PhoneNumberFormat } from 'ngx-intl-tel-input';

@Component({
    selector: 'qc-sms-setup',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        InputTextModule,
        MessageModule,
        ProgressSpinnerModule,
        NgxIntlTelInputModule,
    ],
    template: `
        <div *ngIf="!error">
            <form [formGroup]="phoneForm" class="mb-6">
                <label for="phone" class="block mb-2">Phone Number</label>
                <ngx-intl-tel-input
                    cssClass="form-control w-full"
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="false"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false"
                    [selectedCountryISO]="CountryISO.UnitedStates"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    [inputId]="'phone'"
                    formControlName="phone"
                    [ngClass]="{
                        'ng-invalid ng-dirty': phoneFormSubmitted && phoneForm.controls.phone.errors,
                    }"
                />
                <small
                    *ngIf="phoneFormSubmitted && phoneForm.controls.phone.errors?.['required']"
                    class="text-rose-500 text-xs mt-1 block"
                >
                    Phone number is required
                </small>
                <small
                    *ngIf="(phoneFormSubmitted || phoneForm.controls.phone.dirty) && phoneForm.controls.phone.errors?.['validatePhoneNumber']"
                    class="text-rose-500 text-xs mt-1 block"
                >
                    Invalid phone number format
                </small>
            </form>

            <div *ngIf="isLoading" class="flex justify-center my-4">
                <p-progressSpinner [style]="{ width: '50px', height: '50px' }" />
            </div>

            <p-message *ngIf="error" severity="error" [text]="error" styleClass="w-full mb-4 block"></p-message>
            <p-button
                type="button"
                label="Send Verification Code"
                icon="pi pi-send"
                styleClass="w-full mt-12"
                [loading]="isLoading"
                [disabled]="phoneForm.invalid"
                (click)="onSendCode.emit()"
                size="large"
            />
        </div>

        <p-message *ngIf="error" severity="error" [text]="error" styleClass="w-full mb-4 block"></p-message>
        <p-button
            *ngIf="error"
            type="button"
            label="Try Another Method"
            icon="pi pi-arrow-left"
            class="w-full mt-12"
            (click)="tryAnotherMethod.emit()"
            size="large"
        />
    `,
})
export class SmsSetupComponent {
    @Input() phoneForm!: FormGroup;
    @Input() phoneFormSubmitted: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() error: string = '';
    @Input() setupSuccess: boolean = false;

    @Output() onSendCode = new EventEmitter<void>();
    @Output() tryAnotherMethod = new EventEmitter<void>();

    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Poland];
}
